import { gql } from '@apollo/client'

export const GET_CURRENT_USERINFO = gql`
  query getCurrentUserInfo {
    userinfo: copyrightUserInfo {
      avatarUrl
      nickname
      tradePwdStatus
      authStatus
      backgroundUrl
      blockChainAddress
      userRoleInfo {
        artist
        aiArtist
      }
      personalizedSignature
      inviteCode
      metaWalletBalance {
        availableBalance
        walletId
        withdrawalMoney
        cards {
          bank
          bankCardNumber
          bankId
          default
          openingBank
          status
        }
      }
      integralWalletBalance {
        availableBalance
        frozenBalance
      }
      base {
        uid
        mobile
      }
      userType # 区分机构用户｜个人用户
      whiteList {
        isArtworkAllowNoSellAllPower
      }
      social {
        fansCount
        followCount
        likesCount: squareLikesCount
        followStatus
        uid
      }
      authInfo {
        needMakeUp
        idCard
        realName
      }
      deserved #是否白名单（ai创作）
      muzzleEndTime
      muzzleStatus
    }
    aiEquity: accountModule {
      userMemberCardList {
        cardType
        name
      }
    }
  }
`

export const GET_DEFAULT_AVATARS = gql`
  query getDefaultAvatars {
    copyrightUserAvatars {
      systemUrl {
        id
        avatarUrl
      }
    }
  }
`

export const GET_USERINFO = gql`
  query getUserInfo($uid: Long) {
    userinfo: copyrightUserInfo(uid: $uid) {
      backgroundUrl
      avatarUrl
      nickname
      personalizedSignature
      userRoleInfo {
        artist
        aiArtist
      }
      userType
      social {
        fansCount
        followCount
        likesCount: squareLikesCount
        followStatus
        uid
        # 作画次数
        aiPictureCount
        # 发布创作
        squareCount
        # 被同款数
        aiSameStyleCount

        # 同款榜
        aiSameStyleRank
        # 作画榜
        aiPictureRank
        # 粉丝榜
        fansRank
      }
    }
  }
`

export const GET_REAL_NAME_INFO = gql`
  query getRealNameInfo {
    copyrightAuthInfo {
      idCard
      realName
    }
  }
`

export const REAL_NAME_AUTH = gql`
  mutation realNameAuth($param: RealNameAuthParam!) {
    status: realNameAuth(param: $param)
  }
`

export const REAL_NAME_AUTH_COMPLETION = gql`
  mutation realNmaeAuthCompletion($param: RealNameAuthMakeUpParam!) {
    status: realNameAuthMakeUp(param: $param)
  }
`

export const UPDATE_USER_BASE_INFO = gql`
  mutation updateUserBaseInfo($param: MyCopyrightInfoParam!) {
    status: updateMyCopyrightInfo(param: $param)
  }
`

export const ORGANIZATION_AUTH = gql`
  mutation organizationAuth($param: CompanyAuthParam!) {
    companyAuth(param: $param) {
      reason
      result
    }
  }
`

export const GET_ORGANIZATION_AUTH_INFO = gql`
  query getCompanyAuthInfo {
    copyrightCompanyAuthInfo {
      businessLicenseUrl
      companyName
      id
      legalPersonIdNo
      legalPersonMobile
      legalPersonName
      unifiedSocialCreditCode
    }
  }
`
export const GET_AUTH_USER_INFO = gql`
  query getAuthUserInfo {
    copyrightAuthInfoPlaintext {
      idCard
      realName
      idCardFrontUrl
      idCardBackUrl
    }
  }
`

/** 我拥有的所有权作品列表 */
export const GET_OWNED_PRODUCT_LIST = gql`
  query getOwnedProductList($first: Int, $offset: Int, $userId: Int) {
    itemModule {
      productList: ownerArtworkPage(
        page: { first: $first, offset: $offset }
        userId: $userId
      ) {
        edges {
          node {
            id
            artworkUrl
          }
        }
      }
    }
  }
`
